import {CampaignTags} from './campaign_tags'

class EditMultiModal extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value
    this._is_admin = this.getAttribute('is_admin') === "true" ? true : false;
    this.innerHTML = `
    <style>
      edit-multi-modal .modal-lg {
        width: 1000px;
        min-height: 850px;
      }

      edit-multi-modal .modal-content {
        min-height: 480px;
      }

      #editCampaignModal input[type="radio"] {
        display: none;
      }

      .edit-multi-switch {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .edit-multi-col {
        padding: 0 25px !important;
        margin: 26px 0 30px 0;
      }

      #edit-multi-rtn {
        margin-bottom: 30px;
      }

      edit-multi-modal campaign-tags button {
        float: right;
      }

      edit-multi-modal i {
        font-style: italic;
        font-weight: normal;
      }

      .edit-multi-switch, .edit_multi_disc_language,
      .ring_to_settings, #multi_edit_audio,
      .ring_to_endpoint {
        margin-bottom: 20px;
      }

      .edit-multi-col:first-child {
        border-right: 1px solid;
      }

      .edit-multi-col:nth-child(2) {
        border-left: 1px solid;
        margin-left: -1px;
      }

      .edit_multi_confirm {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 490px;
        padding-top: 20px;
        font-size: 18px;
      }
      
    </style>
    <button type="button" class="btn btn-primary" id="edit_multi_campaigns" data-cy="edit_multi_campaigns" disabled>Edit Selected</button>
    <div class="modal fade bd-example-modal-sm" id="editCampaignModal" data-cy="edit-multi-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Selected Campaigns</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="errors col-md-12"></div>
            <div class="row edit_multi_main">
              <div class="col-sm-6 edit-multi-col">
                <div class="edit-multi-switch">
                  <label>CallShield</label>
                  <div class="btn-group callshield" data-cy="multi_callshield" role="group" aria-label="...">
                    <input id=callshieldMultT type=radio name=callshieldMult value=true><label for=callshieldMultT class="tern_toggle left">On</label><input id=callshieldMultNC type=radio name=callshieldMult value=no_change checked><label for=callshieldMultNC class="tern_toggle mid">No Change</label><input id=callshieldMultF type=radio name=callshieldMult value=false><label for=callshieldMultF class="tern_toggle right">Off</label>
                  </div>
                </div>
                ${this._is_admin ? `
                <div class="edit-multi-switch">
                  <label>LeadScore</label>
                  <div class="btn-group leadscore" data-cy="multi_leadscore" role="group" aria-label="...">
                    <input id=leadscoreMultT type=radio name=leadscoreMult value=1><label for=leadscoreMultT class="tern_toggle left">On</label><input id=leadscoreMultNC type=radio name=leadscoreMult value=no_change checked><label for=leadscoreMultNC class="tern_toggle mid">No Change</label><input id=leadscoreMultF type=radio name=leadscoreMult value=0><label for=leadscoreMultF class="tern_toggle right">Off</label>
                  </div>
                </div>
                ` : ''}
                <div class="edit-multi-switch">
                  <label>Active</label>
                  <div class="btn-group active" data-cy="multi_active" role="group" aria-label="...">
                    <input id=activeMultT type=radio name=activeMult value=1><label for=activeMultT class="tern_toggle left">On</label><input id=activeMultNC type=radio name=activeMult value=no_change checked><label for=activeMultNC class="tern_toggle mid">No Change</label><input id=activeMultF type=radio name=activeMult value=2><label for=activeMultF class="tern_toggle right">Off</label>
                  </div>
                </div>
                <div class="edit-multi-switch">
                  <label>Call Recording</label>
                  <div class="btn-group enable_call_recording" data-cy="multi_enable_call_recording" role="group" aria-label="...">
                    <input id=callRecMultT type=radio name=callRecMult value=true><label for=callRecMultT class="tern_toggle left">On</label><input id=callRecMultNC type=radio name=callRecMult value=no_change checked><label for=callRecMultNC class="tern_toggle mid">No Change</label><input id=callRecMultF type=radio name=callRecMult value=false><label for=callRecMultF class="tern_toggle right">Off</label>
                  </div>
                </div>
                <select class="form-control edit_multi_disc_language hidden">
                  <option value="null">Select Recording Announcement Language</option>
                  <option value="1">English</option>
                  <option value="2">Spanish</option>
                  <option value="3">French</option>
                </select>
                <div class="edit-multi-switch">
                  <label>Texting Enabled</label>
                  <div class="btn-group multi_texting" data-cy="multi_texting" role="group" aria-label="...">
                    <input id=textingMultT type=radio name=textingMult value=true><label for=textingMultT class="tern_toggle left">On</label><input id=textingMultNC type=radio name=textingMult value=no_change checked><label for=textingMultNC class="tern_toggle mid">No Change</label><input id=textingMultF type=radio name=textingMult value=false><label for=textingMultF class="tern_toggle right">Off</label>
                  </div>
                </div>
                <div class="col-md-12 no-gutters">
                    <i>• Options to add Outbound Texting & 10DLC Campaign are in Edit Campaign</i>  
                  </label>
                </div>
                <div class="col-md-12 no-gutters texting_recipients hidden">
                  <label>Texting Team</label>
                  <select name="teams" is="teams-select" class="select-teams form-control"></select>
                </div>
              </div>

              <div class="col-sm-6 edit-multi-col">
                <div class="tags-container"></div>
                <label>Ring to Settings</label>
                <select class="form-control ring_to_settings">
                  <option value="no_change">No Change</option>
                  <option value="ring_to_number">Ring to Number</option>
                  <option value="call_treatment">Call Treatment</option>
                </select>
                <div id="multi_ring_to_panel" data-cy="multi_ring_to_panel" class="hidden">
                  <ul>
                    <li><i>*Not applied to Campaigns with active Treatments</i></li>
                  </ul>
                  <input type="text" is="ring-to-endpoint" class="form-control ring_to_endpoint" id="multi_camp_rtn" data-cy="multi_camp_rtn" data-key="ring_to_endpoint" placeholder="Leave empty to not change existing ring to number">
                  <div id="multi_edit_audio" class="col-sm-12 no-gutters">
                    <div class="col-sm-12 no-gutters"><label>Consumer Greeting</label></div>
                    <div class="col-sm-12 no-gutters audio-select-row">
                      <select is=audio-select target_audio_type=2 class="form-control" id="consumer-greeting-select" data-cy="consumer-greeting" default_option_text="Off" no_change_option="true" data-selected="no_change"></select>
                      <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="2">Manage</button>
                    </div>
                    <div class="col-sm-12 no-gutters"><label>Sales Rep Whisper</label></div>
                    <div class="col-sm-12 no-gutters audio-select-row">
                      <select is=audio-select target_audio_type=4 class="form-control" id="sales-rep-select" data-cy="sales-rep-whisper" default_option_text="Off" no_change_option="true" data-selected="no_change"></select>
                      <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="4">Manage</button>
                    </div>
                  </div>
                  <div class="col-md-12 no-gutters">
                    <div class="edit-multi-switch">
                      <label>Call Ends - Assign Representative Code</label>
                      <div class="btn-group active" data-cy="multi_active" role="group" aria-label="...">
                        <input id=repCodeMultT type=radio name=repCodeMult value=1><label for=repCodeMultT class="tern_toggle left">On</label><input id=repCodeMultNC type=radio name=repCodeMult value=no_change checked><label for=repCodeMultNC class="tern_toggle mid">No Change</label><input id=repCodeMultF type=radio name=repCodeMult value=2><label for=repCodeMultF class="tern_toggle right">Off</label>
                      </div>
                    </div>
                  </div>
                  <div class="panel-body form-horizontal col-md-12 no-gutters" style="padding-top: 0px">
                    <button type="button" class="btn btn-outline-primary" id="show_integrations" data-cy="show_integrations">Add New Integration</button>
                    <div class="campaign_webhooks_container hidden" data-cy="campaign-webhooks">
                      <label>Add New Integration</label>
                      <webhook-form></webhook-form>
                    </div>
                  </div>
                </div>
                <div id="multi_call_treat_panel" data-cy="multi_call_treat_panel" class="hidden">
                  <ul>
                    <li><i>*Applied to all selected Campaigns</i></li>
                  </ul>
                  <select is=treatments-select class="form-control call_treatments_id" data-cy="call-treat-id" value=""></select>
                </div>
              </div>

              <div class="col-md-12 edit-campaign-buttons">
                <span style="margin-left: 16px"><i>**Any changes that cannot be applied here must be done in Edit Campaign</i></span>
                <button type="button" class="btn btn-primary campaign_next pull-right campaign-row-button" data-cy="next-multi-edit">Next</button>
                <button type="button" class="btn btn-outline-secondary cancel pull-right campaign-row-button">Cancel</button>
              </div>
            </div>

            <div class="edit_multi_confirm no-gutters col-md-12 hidden">
              <div class="col-md-12">
                <p>Are you sure you want to update all selected campaigns?</p>
              </div>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary save campaign-row-button pull-right" data-cy="save-multi-edit">Save</button>
                <button type="button" class="btn btn-outline-secondary back campaign-row-button pull-right">Cancel</button>
              </div>
            </div>

            <div class="edit_multi_saving text-center hidden">
              <h3>Saving Campaigns...</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    `;

    this.querySelector(".tags-container").appendChild(new CampaignTags(this.domain_id));
    this.modal = this.querySelector('.modal');
    this.querySelector('#edit_multi_campaigns').onclick = this.show.bind(this);
    this.querySelector('.campaign_next').onclick = this.next.bind(this);
    this.querySelector('.save').onclick = this._save.bind(this);
    this.querySelector('.back').onclick = this.back.bind(this);
    this.querySelectorAll('.cancel, .close').forEach(e => {
      e.onclick = this.cancel.bind(this);
    })

    this.querySelector('.enable_call_recording').addEventListener('click', function() {
      if(this.querySelector('input[name="callRecMult"]:checked').value == 'true') {
        this.querySelector('.edit_multi_disc_language').classList.remove('hidden');
      } else {
        this.querySelector('.edit_multi_disc_language').classList.add('hidden');
      }
    }.bind(this))

    this.querySelector('.multi_texting').addEventListener('click', function() {
      if(this.querySelector('input[name="textingMult"]:checked').value == 'true') {
        this.querySelector('.texting_recipients').classList.remove('hidden');
      } else {
        this.querySelector('.texting_recipients').classList.add('hidden');
      }
    }.bind(this))

    this.querySelector('.ring_to_settings').addEventListener('change', function(e) {
      if(e.target.value == 'no_change') {
        this.querySelector('#multi_ring_to_panel').classList.add('hidden');
        this.querySelector('#multi_call_treat_panel').classList.add('hidden');
      } else if (e.target.value == 'ring_to_number') {
        this.querySelector('#multi_ring_to_panel').classList.remove('hidden');
        this.querySelector('#multi_call_treat_panel').classList.add('hidden');
      } else {
        this.querySelector('#multi_ring_to_panel').classList.add('hidden');
        this.querySelector('#multi_call_treat_panel').classList.remove('hidden');
      }
    }.bind(this))

    this.querySelector('#show_integrations').addEventListener('click', function() {
      this.querySelector('#show_integrations').classList.add('hidden');
      this.querySelector('.campaign_webhooks_container').classList.remove('hidden');
    }.bind(this))

    this._defaults ={
      record: this.querySelector('#callRecMultNC'),
      treatment: null, //Can't be selected here as the options haven't loaded yet.
      active: this.querySelector('#activeMultNC'),
      callshield:this.querySelector('#callshieldMultNC'),
      textingEnabled: this.querySelector('#textingMultNC'),
      representive_code: this.querySelector('#repCodeMultNC'),
    }
    if(this._is_admin) {
      this._defaults.leadscore = this.querySelector('#leadscoreMultNC')
    }
  }

  show(){
    $(this.modal).modal('show');
  }

  cancel(){
    $(this.modal).modal('hide');
    this._reset();
  }

  back() {
    this.querySelector('.edit_multi_confirm').classList.add('hidden');
    this.querySelector('.edit_multi_saving').classList.add('hidden');
    this.querySelector('.edit_multi_main').classList.remove('hidden');
  }

  next() {
    if(this.validate()) {
      this.querySelector('.edit_multi_main').classList.add('hidden');
      this.querySelector('.edit_multi_confirm').classList.remove('hidden');
    }
  }

  _reset(){
    let d = this._defaults;
    d.record.checked = 'checked';
    d.active.checked = 'checked';
    d.callshield.checked = 'checked';
    if(this._is_admin) {
      d.leadscore.checked = 'checked';
    }
    d.textingEnabled.checked = 'checked';
    d.representive_code.checked = 'checked';
    this.querySelector('.edit_multi_disc_language').classList.add('hidden');
    this.querySelector('.texting_recipients').classList.add('hidden');
    this.querySelector('#multi_ring_to_panel').classList.add('hidden');
    this.querySelector('#multi_call_treat_panel').classList.add('hidden');
    this.querySelector('.edit_multi_confirm').classList.add('hidden');
    this.querySelector('.edit_multi_saving').classList.add('hidden');
    this.querySelector('.edit_multi_main').classList.remove('hidden');
    this.querySelector('.modal-header .close').classList.remove('hidden');
    this.querySelector('.ring_to_settings').value = 'no_change';
    this.querySelector('.ring_to_endpoint').value = '';
    this.querySelector('.edit_multi_disc_language').value = 'null';
    this.querySelector('.select-teams').value = '';
    this.querySelector('.call_treatments_id').value = '';
    this.querySelector('#consumer-greeting-select').value = 'no_change';
    this.querySelector('#sales-rep-select').value = 'no_change';
    
    this.querySelectorAll('campaign-tag .fa-minus').forEach(e => {
      e.click();
    })
    let webhooks = this.querySelectorAll('webhook-form .fa-minus').length;
    while(webhooks > 1) {
      this.querySelector('webhook-form .fa-minus').click();
      webhooks --;
    }
    this.querySelector('.action_id').value = 'null';
    this.querySelector('.action_timing').value = '1';

    this.validate();
  }

  async _save(){
    this.querySelector('.edit_multi_confirm').classList.add('hidden');
    this.querySelector('.edit_multi_saving').classList.remove('hidden');
    this.querySelector('.modal-header .close').classList.add('hidden');
    let data = {};
    let target_id = this.querySelector('.call_treatments_id').value;
    let ring_to_number = this.querySelector('#multi_camp_rtn').value;
    let consumer_greeting_id = this.querySelector('#consumer-greeting-select').value;
    let sales_rep_whisper_id = this.querySelector('#sales-rep-select').value;
    let enable_call_recording = this.querySelector('input[name="callRecMult"]:checked').value;
    let active = this.querySelector('input[name="activeMult"]:checked').value;
    let callshield = this.querySelector('input[name="callshieldMult"]:checked').value;
    let textingEnabled = this.querySelector('input[name="textingMult"]:checked').value;
    let representive_code = this.querySelector('input[name="repCodeMult"]:checked').value;

    let selected_campaigns = CampaignsList.gTable.rows('.selected').data().toArray();
    data.domain_id = this.domain_id;
    data.campaigns_to_update = selected_campaigns.map(campaign => campaign.id);
    data.campaign_tag_data = this.querySelector("campaign-tags").getData();


    if(enable_call_recording != "no_change") {
      data.enable_call_recording = enable_call_recording==="true";
      if(enable_call_recording==="true") {
        data.call_disclaimer = this.querySelector('.edit_multi_disc_language').value;
      }
    }
    if(active != "no_change") {
      data.status = active;
    }
    if(this._is_admin) {
      let leadscore = this.querySelector('input[name="leadscoreMult"]:checked').value;
      if(leadscore != "no_change") {
        data.call_processing_map = leadscore;
      }
    }
    if(callshield != "no_change") {
      data.callshield = callshield==="true";
    }
    
    if(textingEnabled != "no_change") {
      data.did_texting_enabled = textingEnabled==="true";
      if(textingEnabled==="true") {
        data.texting_team_id = this.querySelector('.select-teams').value;
      }
    }
    if(this.querySelector('.ring_to_settings').value == 'call_treatment') {
      data.target_id = target_id;
    }
    if(this.querySelector('.ring_to_settings').value == 'ring_to_number') {
      if(this.querySelector(".ring_to_endpoint").value != "") {
        let ring_to = this.querySelector('.ring_to_endpoint').value.split("@");
        if(ring_to.length == 1) {
          data.ring_to_number = ring_to[0].replace(/\D/g,'');
          data.ring_to_domain = null;
       } else {
          data.ring_to_number = ring_to[0].replace(/\D/g,'');
          data.ring_to_domain = ring_to[1]
       }
      }
      // data.ring_to_endpoint = ring_to_number.trim() == "" ? null : ring_to_number;
      if(representive_code != "no_change") {
        data.representive_code = representive_code == "1";
      }
      if(this.querySelector('#consumer-greeting-select').value != 'no_change') {
        data.consumer_greeting_id = consumer_greeting_id
      }
      if(this.querySelector('#sales-rep-select').value != 'no_change') {
        data.sales_rep_whisper_id = sales_rep_whisper_id
      }
      
      data.webhooks = this.retrieveWebhooks();
    }


    console.log(data)

    let result = await fetch("/admin/campaigns/update_batch", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      body: JSON.stringify(data)
    })

    let response = await result.json();

    if(result.ok && response.success) {
      CampaignsList.reloadData(true);
      TreatmentsManager.reloadTreatments();
      Common.notify('Saved campaigns', 'success');
      this.cancel();
    }
    else {
      this.back();
      this.querySelector(".errors").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> ${response.error != null ? response.error : 'Failed to save campaign.'}
                                                </div>`
    }
  }

  validate() {
    let is_valid = true;
    let errors = '';
    this.querySelectorAll('.error').forEach(e => {
      e.classList.remove('error');
    })
    if(this.querySelector('#callRecMultT').checked && this.querySelector('.edit_multi_disc_language').value == 'null') {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a recording announcement language.
                                                </div>`
      
      this.querySelector('.edit_multi_disc_language').classList.add('error');
      is_valid = false;
    }
    if(this.querySelector('#textingMultT').checked && !this.querySelector('.select-teams').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a team for Texting Enabled.
                                                </div>`
      
      this.querySelector('.select-teams').classList.add('error');
      is_valid = false;
    }
    if(!this.querySelector("campaign-tags").validate()) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> All Campaign Tags must have a Name selected.
                    </div>`;
      is_valid = false;
    }
    if(this._is_admin) {
      if(this.querySelector('#leadscoreMultT').checked && !this.querySelector('#callRecMultT').checked) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong>Warning!</strong> Call Recording must be turned on when turning on LeadScore.
                      </div>`;
        is_valid = false;
      }
    }
    this.querySelector(".errors").innerHTML = errors;
    return is_valid;
  }

  retrieveWebhooks() {
    let data_set = [];
    this.querySelectorAll("webhook-form").forEach((webhook_form) => {
      let webhook_value = webhook_form.getValue();
      if(webhook_value != null) {
        data_set.push(webhook_value);  
      }
    });
    return data_set;
  }
}

customElements.define('edit-multi-modal', EditMultiModal)